export enum DisplayType {
  CHIP = 'chip',
  SELECT = 'select'
}

export type PreferencesValue = {
  id: string
  favoriteClient: boolean
  code: string
}

export type PreferencesResponse = {
  individual: {
    individualPreferenceFamilies: {
      individualPreferenceFamily: {
        individualPreferences: {
          individualPreference: {
            preferenceValues: {
              preferenceValue: PreferencesValue[]
            }
          }[]
        }
      }[]
    }
  }
}

export type PutPreferenceResponse = {
  id: string
}

export type PreferenceReferentialValue = {
  familyCode: string
  preferenceCode: string
  valueCode: string
  valueLabel: string
  valueSegment: string
  valueSensitive: boolean
}

export enum PreferenceValuesTypeEnum {
  MULTI = 'Multi',
  MONO = 'Mono'
}

export interface PreferenceReferential {
  familyCode: string
  preferenceCode: string
  preferenceLabel: string
  preferenceValuesType: PreferenceValuesTypeEnum
  values: PreferenceReferentialValue[]
}

export const ROOM_QUESTIONS = [
  'QTR',
  ['LOF', 'HIF'],
  ['SM', 'NS'],
  'KISB',
  ['NE', 'FE'],
  'RCIV',
  ['OFF', 'ON'],
  'HSI',
  ['OBED', 'TBED'],
  'BAR',
  ['SHW', 'BAT'],
  'CLOSE',
  'SUNR',
  ['FEA', 'FOM', 'HYPO'],
  'FLAP',
  'EPIL',
  'WWH',
  'WH',
  'HEIM',
  'VIM',
  'BLANK',
  'DUV',
  'XBLA',
  'FEAF',
  'SOFM',
  ['W5', 'W4', 'W1', 'W2', 'W6', 'W3']
]

export const FOOD_QUESTIONS = [
  'COFF',
  'Tea',
  ['STILL', 'SPKG'],
  'REXW',
  'WINE',
  'WinW',
  'WINR',
  'WinL',
  'BEER',
  'CHP',
  'COCK',
  'GAS',
  'LOCA',
  'INTERN',
  'PAS',
  'FRT',
  'AME',
  'ARAB',
  'ASI',
  'BRA',
  'CHIN',
  'EEU',
  'FRE',
  'GER',
  'GRE',
  'IND',
  'FOOI',
  'ITAL',
  'JAP',
  'KOR',
  'MED',
  'MEX',
  'MOR',
  'POR',
  'SPAN',
  'THA',
  'VIE',
  'HEAB',
  'LOCF',
  'RSB'
]

export const REGIME_QUESTIONS = [
  'SE_KOS',
  'SE_HAL',
  'SE_HIN',
  'VEGA',
  'VEG',
  'GLU',
  'DAIRY',
  'LSO',
  'LFA',
  'NUT',
  'LPRO',
  'PNUT',
  'SEA',
  'EGG',
  'HPRO',
  'DIA',
  'NAB'
]

export const INTEREST_QUESTIONS = [
  'MAS',
  'FIT',
  'SAUN',
  'RSWP',
  'SPA',
  'HAMM',
  'JACU',
  'WELA',
  'MUS',
  'SHOP',
  'FAM',
  'SPO',
  'CUL',
  'HIST',
  'ARCHI',
  'CIN',
  'EXH',
  'OPE',
  'PAINT',
  'THEA',
  'SHOWS',
  'MSM',
  'CITT',
  'CITA',
  'CITO',
  'COOC',
  'DANC',
  'BOOK',
  'NAT',
  'LOEN',
  'INTER',
  'CASI',
  'TOURA',
  'LOCM',
  'POPR',
  'SHOM'
]

export const RECOMMENDATION_QUESTIONS = [
  'RSWP',
  'QTR',
  'COFF',
  'GLU',
  ['LOF', 'HIF'],
  'Tea',
  'VEG',
  'FIT',
  ['SM', 'NS'],
  ['STILL', 'SPKG'],
  'SE_HAL',
  'MAS',
  'SE_HIN',
  'SE_KOS',
  ['HYPO', 'FEA', 'FOM'],
  'DAIRY',
  'SPA',
  ['NE', 'FE'],
  'SAUN',
  'LSO',
  'REXW',
  'ICIV',
  'WinW',
  ['OFF', 'ON'],
  'HAMM',
  'VEGA',
  'HSI',
  'WINR',
  'JACU',
  'WinL',
  'OBED',
  'DB',
  'BEER',
  'WELA',
  'CHP',
  'LFA',
  'MUS',
  'BAR',
  'NUT',
  'SHOP',
  ['SHW', 'BAT'],
  'COCK',
  'FAM',
  'CLOSE',
  'GAS',
  'PNUT',
  'SUNR',
  'LOCA',
  'INTERN',
  'SEA',
  'SPO',
  'PAS',
  'EGG',
  'CUL',
  'HPRO',
  'HIST',
  'XPIL',
  'FRT',
  'ARCHI',
  'WWH',
  'WH',
  'HEIM',
  'VIM',
  'AME',
  'DIA',
  'BLANK',
  'DUV',
  'XBLA',
  'ARAB',
  'NAB',
  'CIN',
  'ASI',
  'EXH',
  'FEAF',
  'OPE',
  'LPRO',
  'SOFM',
  'BRA',
  'CHIN',
  'PAINT',
  ['W5', 'W4', 'W1', 'W2', 'W6', 'W3'],
  'THEA',
  'EEU',
  'BOPI',
  'SHOWS',
  'FRE',
  'MSM',
  'FLAP',
  'GER',
  'CITT',
  'GRE',
  'CITA',
  'IND',
  'CITO',
  'FOOI',
  'COOC',
  'ITAL',
  'DANC',
  'JAP',
  'BOOK',
  'KOR',
  'NAT',
  'MED',
  'LOEN',
  'MEX',
  'INTER',
  'MOR',
  'CASI',
  'POR',
  'TOURA',
  'SPAN',
  'LOCM',
  'THA',
  'POPR',
  'VIE',
  'SHOM',
  'HEAB',
  'LOCF',
  'RSB'
]

export type QuestionPreferenceType = typeof ROOM_QUESTIONS
export interface UserPreferenceValue extends PreferenceReferentialValue {
  id: string
}
